<template>
    <div class="">
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <div class="vx-card p-4">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full" @mouseover="pauseCall" @mouseleave="resumeCall">
                            <label class="vs-input--label">{{ $t('navMenu.branch') }}</label>
                            <v-select v-model="organizationBranchModel" :options="branchOptions"></v-select>
                        </div>
                        <div class="vx-col md:w-1/4 w-full" @mouseover="pauseCall" @mouseleave="resumeCall">
                            <label class="vs-input--label">{{ $t("minioStorage.dateRange") }}</label>
                            <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                               v-model="dateRange"
                                               class="w-full">
                            </date-range-picker>
                        </div>
                        <div class="vx-col md:w-1/4 w-full" @mouseover="pauseCall" @mouseleave="resumeCall">
                            <label class="vs-input--label">{{ $t('cardCustomer.customerType') }}</label>
                            <v-select v-model="customerTypeModel" :options="customerTypes"></v-select>
                        </div>
                        <div class="vx-col md:w-1/4 w-full" @mouseover="pauseCall" @mouseleave="resumeCall">
                            <vs-button class="mt-6" icon-pack="feather" icon="icon-search" @click.prevent="filter">{{
                                    $t('cardCustomer.search')
                                }}
                            </vs-button>
                        </div>
                    </div>
                </div>

                <div class="vx-row mt-4">
                    <div class="vx-col w-full text-right" v-if="customerDataAll.length > 0">
                        <span class="font-bold">Hiển thị: </span>
                        <span class="">
              {{ customerDataAll.length > 0 ? pageData.numberOfElements + pageData.size * pageData.number : 0 }} / {{
                                pageData.totalElements
                            }}
            </span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="vx-card mt-4 p-4">
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <div class="">
                                        <div class="pl-2">
                                            <div class="w-full" v-if="customerDataAll.length > 0">
                                                <VuePerfectScrollbar ref="scrollDialog"
                                                                     class="scroll-area--nofications-dropdown size-content vx-row w-full"
                                                                     :settings="settings"
                                                                     style="max-height: 80vh">
                                                    <div class="vx-col md:w-1/2 w-full"
                                                         v-for="(data, index) in customerDataAll" :key="index"
                                                         @mouseover="pauseCall" @mouseleave="resumeCall">
                                                        <card-realtime class="mt-2 mb-2" :data="data"/>
                                                    </div>
                                                </VuePerfectScrollbar>
                                                <div class="vx-row mt-4">
                                                    <div class="vx-col md:w-1/2 w-full">
                                                        <div
                                                            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                                                            <span
                                                                class="vx-col mt-2 font-bold">Số phần tử / trang:</span>
                                                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                                                <div
                                                                    class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                  <span class="mr-2">
                                    {{ pageSize }}
                                  </span>
                                                                    <feather-icon icon="ChevronDownIcon"
                                                                                  svgClasses="h-4 w-4"/>
                                                                </div>
                                                                <vs-dropdown-menu>
                                                                    <vs-dropdown-item @click="setPageSize(10)">
                                                                        <span>10</span>
                                                                    </vs-dropdown-item>
                                                                    <vs-dropdown-item @click="setPageSize(20)">
                                                                        <span>20</span>
                                                                    </vs-dropdown-item>
                                                                    <vs-dropdown-item @click="setPageSize(30)">
                                                                        <span>30</span>
                                                                    </vs-dropdown-item>
                                                                </vs-dropdown-menu>
                                                            </vs-dropdown>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col md:w-1/2 w-full">
                                                        <vs-pagination :total="totalPages" v-model="pageNumber"
                                                                       @change="filter()"
                                                                       @mouseover="pauseCall"
                                                                       @mouseleave="resumeCall"></vs-pagination>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full text-center" v-else style="min-height: 100px">
                                                <span class="mt-2">{{ $t('menuCustomer.noRowsToShow') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import authConfig from "@/../auth_config.json";
import moment from "moment";
import CardRealtime from "./card-realtime/CardRealtime.vue";
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import CellRendererImageCustomer from "./cell-renderer/CellRendererImageCustomer.vue";
import DateRangePicker from "../../../components/vue2-daterange-picker/components/DateRangePicker.vue";
import vSelect from 'vue-select'

export default {
    components: {
        moment,
        CardRealtime,
        AgGridVue,
        VuePerfectScrollbar,
        CellRendererImageCustomer,
        DateRangePicker,
        vSelect
    },
    data() {
        return {
            imageDefault: require('@/assets/images/card/businessman.jpeg'),
            customerInfo: {},
            branchOptions: [],
            customerTypes: [
                {value: ["loyalty-customer", "unknown"], label: this.$t('cardCustomer.allCard')},
                {value: ["loyalty-customer"], label: this.$t('cardCustomer.customer'), valueNumber: 0},
                // { value: "guest", label: this.$t('cardCustomer.passers'), valueNumber: 1 },
                {value: ["unknown"], label: this.$t('cardCustomer.unknown'), valueNumber: 1},
            ],
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setHours(0, 0, 0);
                    return date;
                })(),
            },
            listBranch: [],
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            dataRealtime: {},
            showImg: false,
            searchQuery: "",
            components: {},
            customers: [],
            customerData: [],
            customerDataAll: [],
            customerUnknownData: [],
            customerLoyaltyData: [],
            branchId: null,
            faceType: null,
            stopInterval: null,
            pageNumber: 1,
            pageSize: 10,
            totalPages: 1,
            totalElements: 0,
            pageData: {},
        };
    },
    computed: {
        organizationBranchModel: {
            get() {
                let object = this.branchOptions.find(el => el.value === this.branchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.branchId = object ? object.value : null;
            }
        },
        customerTypeModel: {
            get() {
                let object = this.customerTypes.find(el => el.value === this.faceType);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.faceType = object ? object.value : null;
            }
        },
    },
    async created() {
        // await this.getListBranch();
        let listBranch = JSON.parse(localStorage.getItem("branchInfoList") || []);
        this.listBranch = listBranch;
        this.branchOptions = listBranch.map(el => {
            return {
                value: el.id,
                label: el.organizationBranchName
            }
        })
        this.branchOptions.unshift({value: null, label: 'Tất cả'});
        // this.organizationBranchModel = this.branchOptions[0];
        this.customerTypeModel = this.customerTypes[0]
        await this.getCustomers();
        this.$vs.loading();
        await this.filter()
        this.stopInterval = setInterval(() => {
            this.filter();
        }, 10000)
    },
    watch: {},
    // mounted() {
    //   this.$eventBus.$on("realtime-customer", ($event) => {
    //     if ($event) {
    //       let item = $event;
    //       item.checkinTime = item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY HH:mm") : null;
    //       item.urlImage = authConfig.processorDomain + "storage/" + item.imageUrl;
    //       if (item.faceType == "customer") item.customerType = "Khách hàng";
    //       if (item.faceType == "employee") item.customerType = "Nhân viên";
    //       if (item.faceType == "unknown") item.customerType = "Không xác định";
    //       let branch = this.listBranch.find(
    //         (el) => el.organizationId == item.organizationId
    //       );
    //       if (branch) item.organizationBranchName = branch.organizationBranchName;
    //       this.customerDataAll.unshift(item);
    //       let isReload =
    //         item.faceType == "customer" || item.faceType == "employee" ? true : false;
    //       this.filter(isReload);
    //     }
    //   });
    // },
    methods: {
        // async getListBranch() {
        //     let listBranch = JSON.parse(localStorage.getItem("branchInfoList") || []);
        //     this.listBranch = listBranch;
        //     this.branchOptions = listBranch.map(el => {
        //         return {
        //             value: el.id,
        //             label: el.organizationBranchName
        //         }
        //     })
        //     this.branchOptions.unshift({value: null, label: 'Tất cả'});
        //     this.organizationBranchModel = this.branchOptions[0];
        //     this.customerTypeModel = this.customerTypes[0]
        //     return true;
        // },
        filter() {
            return new Promise((resolve, reject) => {
                let start = new Date(this.dateRange.startDate.setHours(0, 0, 0));
                let end = new Date(this.dateRange.endDate.setHours(23, 59, 59));
                // let user = JSON.parse(localStorage.getItem('userInfo'));
                // if (!this.branchId) this.branchId = user.organization.id;
                let searchInfo = {
                    start: start,
                    end: end,
                    organizationBranchId: this.branchId,
                    faceTypes: this.faceType
                };
                // let that = this;
                this.customerData = [];
                // this.$vs.loading();
                let url = '/processor/in-out-history/all?';
                if (this.pageNumber) {
                    url += 'page' + '=' + (this.pageNumber - 1)
                }
                if (this.pageSize) {
                    url += '&size' + '=' + this.pageSize
                }

                this.$processor.post(url, searchInfo).then((response) => {
                    let customerData = response.data.content.map((item) => {
                        item.checkinTime = item.createdAt
                            ? moment(item.createdAt).format("HH:mm DD/MM/YYYY")
                            : null;
                        let branch = this.listBranch.find(
                            (el) => el.id === item.organizationBranchId
                        );
                        if (item.faceType === "loyalty-customer") item.customerType = this.$t('cardCustomer.customer');
                        // if (item.faceType == "employee") item.customerType = this.$t('cardCustomer.employee');
                        if (item.faceType === "unknown") item.customerType = this.$t('cardCustomer.unknown');
                        if (branch)
                            item.organizationBranchName = branch.organizationBranchName;
                        return item;
                    }, []);
                    if (customerData) {
                        this.customerData = customerData;
                        this.customerData = this.customerData.filter(el => el.faceType === 'loyalty-customer' && el.faceType === 'unknown').slice(0, 20);
                        let compare = JSON.stringify(this.customerDataAll) === JSON.stringify(customerData);
                        if (!compare || this.totalPages !== response.data.totalPages || this.pageSize !== response.data.size || this.totalElements !== response.data.totalElements) {
                            this.pageData = response.data;
                            this.totalPages = response.data.totalPages;
                            this.totalElements = response.data.totalElements
                            this.customerDataAll = [];
                            this.customerInfo = {};
                            this.customerDataAll = customerData.filter(el => el.faceType === 'loyalty-customer' || el.faceType === 'unknown');
                            this.customerUnknownData = this.customerDataAll.filter(el => el.faceType === 'unknown');
                            this.customerLoyaltyData = this.customerDataAll.filter(el => el.faceType === 'loyalty-customer');
                            this.customerInfo = this.customerDataAll[0];
                        }
                    }

                    this.$vs.loading.close();
                    resolve()
                }).catch(() => {
                    this.$vs.loading.close();
                    reject()
                });
            })
        },
        getCustomers() {
            return new Promise((resolve) => {
                this.$crm.get(`/customer/find-all`).then((response) => {
                    response.data.forEach((x) =>
                        (x.created_at_display = moment(x.created_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                        ))
                    );
                    this.customers = response.data;
                    this.customerOptions = response.data.map((item) => {
                        return {
                            value: item.id,
                            label: item.customerCode + " " + item.fullName,
                        };
                    });
                    this.customerOptions.unshift({
                        value: null,
                        label: this.$t("menuCustomer.all"),
                    });
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Error",
                        text:
                            err.response.data.message ||
                            err.response.data.error_description ||
                            err.response.data.error,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                    });
                    resolve(false);
                });
            });
        },

        setPageSize(e) {
            this.pageSize = e;
            this.pageNumber = 1;
            this.filter()
        },

        pauseCall() {
            // if (data == 'unknown') { clearInterval(this.stopInterval) }
            // else { clearInterval(this.stopInterval) }
            clearInterval(this.stopInterval)
        },

        resumeCall() {
            this.stopInterval = setInterval(() => {
                this.filter();
            }, 10000)
        },
    },

    destroyed() {
        clearInterval(this.stopInterval);
    }
};
</script>

<style lang="scss">
.bg-image {
    // background-image: url('../../../assets/images/card/bg-card.png');
    height: 250px;
}

.border-status {
    padding: 4px;
    animation: borderHighlight 2s ease infinite;
    border-radius: 50%;
}

.status-success {
    border: 2px solid #04d361;
}

.status-warning {
    border: 2px solid #eb5455d1;
}

.border-info {
    border-radius: 0 5px 5px 0;
}

.status-danger {
    background-color: #eb5455d1;
}

@keyframes borderHighlight {
    50% {
        border-color: transparent;
    }
}
</style>
